import { IconInfo, Text } from 'uikit';

import type { FC } from 'react';

import Styles from './AgreementTopPanel.module.css';

export const AgreementFormTopPanel: FC<{ infoText?: string }> = ({ infoText, children }) => (
    <div className={Styles.topPanel}>
        {children}
        {infoText && (
            <>
                <IconInfo size="s" view="secondary" className={Styles.infoIcon} />
                <Text size="s" view="secondary">
                    {infoText}
                </Text>
            </>
        )}
    </div>
);

AgreementFormTopPanel.displayName = 'AgreementFormTopPanel';
